import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { Location } from '@angular/common';
@Component({
  selector: 'app-qr-login',
  templateUrl: './qr-login.component.html',
  styleUrls: ['./qr-login.component.scss']
})
export class QRLoginComponent implements OnInit {
  public QRkey: string = "";
  public loginWithQRurl = BaseUrlConstantsService.QRLOGIN;
  public role: any;
  public customer: any;
  public email: any;
  public customer_Img: any;
  public isAuthenticated = false;
  public invalidCredentials = false;
  public countDown: number = 3;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public service: BackendApiService,
    public changeUserDashboard: ChangeUsersService,private location: Location,  
  ) {}

  public saveUser(): void {
    let body: any;
    let endpoint: string;

    if (this.QRkey) {
      // Use the QR login endpoint (adjust as needed)
      endpoint = this.loginWithQRurl
      body = { QRkey: this.QRkey };
    } else {
      this.service.showError("No QR key provided");
      return;
    }

  
    this.changeUserDashboard.loader(true);

  
    this.service.postDataSigin(endpoint, body)
      .then((response) => {
     
        const responseData = JSON.parse(JSON.stringify(response)).data;
        if (responseData.status === "success") {
          
          localStorage.setItem("loginStatus", "yes");
          localStorage.setItem("admin_client_id", null);

          // Extract user and token data
          const user = responseData.body.user;
          const token = responseData.body.token;
          const userName = user.full_name;
          const companyName = user.company_name;
          const countryName = user.country;
          const userID = user.id;

          
          this.role = user.role;
          this.customer = user.role;
          this.email = user.email.toLowerCase();
          this.customer_Img = user.profile_image;

          // Store values in local storage
          localStorage.setItem("associated_clientid", user.associated_clientid);
          localStorage.setItem("token", token);
          localStorage.setItem("country", countryName);
          localStorage.setItem("admin_client_name", "");
          localStorage.setItem("clientTimeZone", user.timezone);
          localStorage.setItem("user_id", userID.toString());
          localStorage.setItem("customerName", this.customer);
          localStorage.setItem("userEmail", this.email);
          localStorage.setItem("role", this.role);
          localStorage.setItem("user_name", userName);
          localStorage.setItem("company_name", companyName);
          localStorage.setItem("user_img", this.customer_Img);
          localStorage.setItem("client_id", user.client_id);
          localStorage.setItem("QR-login", "true");
          localStorage.setItem("timestamp", Date.now().toString());

          this.service.updateTokenOnLogin()
          this.changeUserDashboard.login("Log In");

          // Navigate based on user role
          switch (this.role) {
            case "CLIENT":
              this.service.showSuccess("You are successfully logged in");
              this.router.navigate(["/device-reports"]);
              break;
            case "ADMIN":
              this.service.showSuccess("You are successfully logged in");
              this.router.navigate(["/admin-dashborad"]);
              break;
            case "USER":
              this.service.showSuccess("You are successfully logged in");
              this.router.navigate(["/device-reports"]);
              break;
            case "ACCOUNT_MANAGER":
              this.service.showSuccess("You are successfully logged in");
              this.router.navigate(["/manager-client-list"]);
              break;
            case "OEM":
              this.service.showSuccess("You are successfully logged in");
              this.router.navigate(["/OEM-Client"]);
              break;
            default:
              this.service.showSuccess("You are successfully logged in");
              this.router.navigate(["/"]);
          }
        } else if (responseData.status === "fail") {
          this.service.showError("Incorrect username or password");
          this.invalidCredentials = true;
        } else {
          this.service.showError("Something went wrong.");
          this.invalidCredentials = true;
        }
      })
      .catch((error) => {
        this.service.showError("QR Login failed");
        this.invalidCredentials = true;
      })
      .finally(() => {
      
        this.changeUserDashboard.loader(false);
      });
  }

  ngOnInit(): void {
    
    this.route.queryParams.subscribe(params => {
      const QRKey = params['QRKey'];
      if (QRKey) {
        // console.log('QRKey:', QRKey);
        this.QRkey=QRKey

      } else {
        console.error('No QR Key provided in URL!');
      }
    
      this.location.replaceState('/QRlogin'); 
      this.saveUser();
    });

   
    setTimeout(() => {
      this.isAuthenticated = true;
      this.startCountdown();
    }, 2000);
  }


  startCountdown(): void {
    const timer = setInterval(() => {
      this.countDown--;
      if (this.countDown <= 0) {
        clearInterval(timer);
       
        if (this.invalidCredentials) {
          this.router.navigate(['/login']);
        } else {
          this.router.navigate(['/login']);
        }
      }
    }, 1000);
  }
}
